export enum TabNames {
  GOALS = 'Goals',
  COMMUNICATIONS = 'Communications',
  USERS_REMOVED = 'User drop-offs'
}
